<template>
  <v-form v-model="valid" ref="mainForm">
    <CatalogueLive code="cheminement" :live="liveSasReconnaissanceArm(9002)" v-model="sasReconnaissanceArm.cheminement" />
  </v-form>
</template>

<script>
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
export default {
  mixins: [CataloguesHelpers, StepFormWithValidation],
  components: {},
  props: {
    sas: { type: Object }
  },

  computed: {
    sasReconnaissanceArm() {
      return this.sas.sasReconnaissanceArmFranceQuebec
    }
  },
  methods: {
    liveSasReconnaissanceArm(cle) {
      return { endpoint: "sas-reconnaissance-arm-france-quebec", cle: cle, fileId: this.sasReconnaissanceArm.id }
    }
  }
}
</script>

<style></style>
